export default __webpack_public_path__ + "static/doodle-work-efcdd65d3130dfd6bd5b34d25d4e801c.svg";